/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const DropdownArrowIcon = (props) => {
  return (
      <svg width="8px" height="4px" viewBox="0 0 8 4" version="1.1">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g fill={(props.color) ? props.color : '#31374F'}>
                  <polygon id="Triangle-3" points="8 0 4 4 0 0" />
              </g>
          </g>
      </svg>
  )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/DropdownArrow/DropdownArrow.tsx